import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=c2ae69e0&"
import script from "./ReviewList.vue?vue&type=script&lang=js&"
export * from "./ReviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports